import Api from "@/api/Api";
import i18n from "@/config/i18n";
import store from "@/config/store";
import Cookies from "@/pages/CMS/Cookies.vue";
import icons from "@/utils/icons";
import { DEFAULT_CONFIGURATION, FooterMenuItemType, InstanceConfiguration, NewsletterFooterDisplayStrategy, ProductsDisplayMode, ProductsPagingMode } from "~/core/config/InstanceConfiguration";

export const configuration: InstanceConfiguration = {
    ...DEFAULT_CONFIGURATION,
}

configuration.corporateName = "Shop E Dom"
configuration.header.icons.showBecomeSeller = false
configuration.header.icons.showContact = false
configuration.header.icons.showQuickOrder = false
configuration.header.rootCategory = {
    enabled: true,
    modal: {
        showAsSelector: false,
        showAsList: true,
        showFocused: false,
        closeOnNewSelection: true
    }
};
configuration.header.topBanner.enabled = true
configuration.header.topBanner.staticItems = [{
    id: "allIncludePrices",
    isActive: true,
    titleKey: "topBar.allIncludePrices.titleHTML",
    buttonLabelKey: "topBar.allIncludePrices.button",
    buttonUrl: "https://livraison-dom-tom.fr/transparence-prix"
}]
configuration.navigation.catalogChange.returnToHome = false;
configuration.product.pictureIconFlags = [{
    attributeId: "product_eligible_by_flight",
    classSuffix: "airplane",
    labelKey: "sed.product_flag_deliverable_by_plane",
    iconUrl: "/assets/images/air-shipping-icon.png"
}];
configuration.home.promotions.slidesPerView.xl = 5
configuration.home.promotions.slidesPerView.large = 4
configuration.home.promotions.slidesPerView.medium = 3
configuration.home.promotions.slidesPerView.small = 2
configuration.footer.newsletter = {
    enabled: true,
    strategy: NewsletterFooterDisplayStrategy.FULL_WIDTH_BEFORE_COLUMNS
}
configuration.footer.menuCol1 = {
    slug: 'a-propos',
    items: [
        {
            slug: 'about-us',
            url: 'https://livraison-dom-tom.fr/qui-sommes-nous/',
            type: FooterMenuItemType.EXTERNAL
        },
        {
            slug: 'become-supplier',
            url: 'https://livraison-dom-tom.fr/vendre-dans-les-droms/',
            type: FooterMenuItemType.EXTERNAL
        },
        {
            slug: 'press-contact',
            url: 'https://livraison-dom-tom.fr/contact/',
            type: FooterMenuItemType.EXTERNAL
        },
    ]
}
configuration.footer.menuCol2 = {
    slug: 'services',
    items: [
        {
            slug: 'guaranties',
            url: 'conditions-generales-de-ventes#garantie',
            moqSlug: 'selling-terms'
        },
        {
            slug: 'payment-methods',
            url: 'conditions-generales-de-ventes#conditions-paiement',
            moqSlug: 'selling-terms'
        },
        // {
        //     url: '/securite-de-paiement',
        //     slug: 'payment-security',
        //     target: '_self'
        // },
        {
            slug: 'shipping',
            url: 'livraison-et-expeditions',
            moqSlug: 'shipping'
        },
        {
            slug: 'returns',
            url: 'conditions-de-retours-et-de-remboursement',
            moqSlug: 'returns'
        },
        {
            slug: 'recruitment',
            url: 'https://livraison-dom-tom.fr/recrutement/',
            type: FooterMenuItemType.EXTERNAL
        }
    ]
}
configuration.footer.menuCol3 = {
    slug: "legal",
    items: [
        {
            slug: 'selling-terms',
            url: 'conditions-generales-de-ventes'
        },
        {
            slug: 'usage-terms',
            url: 'conditions-generales-d-utilisation'
        },
        {
            slug: 'legal-notices',
            url: 'mentions-legales'
        },
        {
            slug: 'privacy-policy',
            url: 'politique-de-protection-des-donnees-personnelles'
        },
        {
            slug: 'cookies-management',
            url: 'gestion-des-cookies',
            component: Cookies
        },
    ]
}
configuration.footer.reassuranceIcons = [
    {
        label: 'components.orkReassurance.fastDelivery',
        iconUrl: '/assets/images/reassurance/Fast deliver.png',
    },
    {
        label: 'components.orkReassurance.securedPaiement',
        iconUrl: '/assets/images/reassurance/paiement securise.png',
    },
    {
        label: 'components.orkReassurance.customerCare',
        iconUrl: '/assets/images/reassurance/sav.png',
    }
]
configuration.footer.social = [
    {
        label: 'Instagram',
        link: 'https://www.instagram.com/shopedom_market/',
        icon: icons.instagram
    },
    {
        label: 'LinkedIn',
        link: 'https://www.linkedin.com/company/shop-e-dom-market/about/',
        icon: icons.linkedIn
    },
    {
        label: 'Facebook',
        link: 'https://www.facebook.com/profile.php?id=61564230622113',
        icon: icons.facebook
    },
    {
        label: 'Tik Tok',
        link: 'https://www.tiktok.com/@shopedom_market',
        icon: icons.tiktok
    }
]
configuration.footer.contactInfo = {
    email: "marketing@sed-market.com",
    tel: "+33 (0)6 49 68 43 92"
}
configuration.productList.navbar.showDisplayModeSelection = false
configuration.productList.navbar.defaultDisplayMode = ProductsDisplayMode.SMALL
configuration.productList.desktopPagingMode = ProductsPagingMode.INFINITE_SCROLL
configuration.productList.autoLoadNextProducts = true
configuration.productList.category.showCategoriesPage = false
configuration.productList.category.minLevelToShowProducts = 2
configuration.category.showMarketing = true
configuration.checkout.shipping.isAddressEligible = address => Api.sed.getRootCategoryByCountryCode(address.country) === store.getters.getRootCategoryPath
configuration.checkout.shipping.noEligibleAddressMessage = () => i18n.t('Please add a shipping address located {0}', [Api.sed.getCountryNameFromRootCategory(store.getters.getRootCategoryPath)]).toString()
configuration.checkout.shipping.estimatedDateStrategy = "PERIOD"
configuration.forms.captcha.showNotice = false;